var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-healing"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-262.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Healing",
    transform: "translate(264.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-healing"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#27CAE3",
    xlinkHref: "#path-1-healing"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.04,
    stroke: "#00ADC6",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9893,20.0103 L19.9583,21.0413 C19.3703,21.6293 18.9573,21.9573 17.9903,20.9903 L14.9793,17.9793 C13.9923,16.9913 14.4513,16.5493 15.0103,15.9893 L16.0203,14.9793 C16.6463,14.3543 17.0433,14.0433 18.0193,15.0193 L21.0083,18.0083 C21.9623,18.9623 21.6343,19.3663 20.9893,20.0103 Z M26.3543,21.7283 C26.7703,22.1433 27.0003,22.6973 27.0003,23.2863 C27.0003,23.8753 26.7703,24.4283 26.3543,24.8443 L24.8443,26.3543 C24.0103,27.1873 22.5613,27.1863 21.7273,26.3543 L9.6453,14.2723 C9.2293,13.8563 9.0003,13.3023 9.0003,12.7143 C9.0003,12.1253 9.2293,11.5723 9.6453,11.1563 L11.1553,9.6463 C11.5723,9.2293 12.1253,9.0003 12.7143,9.0003 C13.3023,9.0003 13.8553,9.2293 14.2723,9.6453 L26.3543,21.7283 Z M14.2723,26.3543 C13.4383,27.1873 11.9893,27.1863 11.1553,26.3543 L9.6453,24.8433 C9.2293,24.4283 9.0003,23.8753 9.0003,23.2863 C9.0003,22.6973 9.2293,22.1433 9.6453,21.7273 L11.9593,19.4143 L16.5863,24.0413 L14.2723,26.3543 Z M21.7273,9.6463 C22.5613,8.8133 24.0103,8.8133 24.8443,9.6453 L26.3543,11.1563 C26.7703,11.5723 27.0003,12.1253 27.0003,12.7143 C27.0003,13.3023 26.7703,13.8563 26.3543,14.2723 L24.0413,16.5863 L19.4143,11.9583 L21.7273,9.6463 Z M25.4553,18.0003 L27.7683,15.6873 C28.5623,14.8933 29.0003,13.8373 29.0003,12.7143 C29.0003,11.5913 28.5623,10.5353 27.7683,9.7413 L26.2593,8.2313 C25.4643,7.4373 24.4083,7.0003 23.2863,7.0003 C22.1643,7.0003 21.1083,7.4373 20.3133,8.2313 L18.0003,10.5443 L15.6863,8.2313 C14.8913,7.4373 13.8363,7.0003 12.7143,7.0003 C11.5923,7.0003 10.5363,7.4373 9.7413,8.2313 L8.2313,9.7413 C7.4373,10.5353 7.0003,11.5913 7.0003,12.7143 C7.0003,13.8373 7.4373,14.8933 8.2313,15.6863 L10.5453,18.0003 L8.2313,20.3133 C7.4373,21.1073 7.0003,22.1623 7.0003,23.2863 C7.0003,24.4093 7.4373,25.4653 8.2313,26.2583 L9.7413,27.7693 C10.5363,28.5633 11.5923,29.0003 12.7143,29.0003 C13.8363,29.0003 14.8913,28.5633 15.6863,27.7683 L18.0003,25.4553 L20.3133,27.7693 C21.1083,28.5633 22.1643,29.0003 23.2863,29.0003 C24.4083,29.0003 25.4643,28.5633 26.2593,27.7683 L27.7683,26.2593 C28.5623,25.4653 29.0003,24.4093 29.0003,23.2863 C29.0003,22.1623 28.5623,21.1073 27.7683,20.3133 L25.4553,18.0003 Z",
    id: "Fill-1",
    fillOpacity: 0.65,
    fill: "#27CAE3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealing);
export default __webpack_public_path__ + "static/media/Healing.9c55428389524e235913daf979695fe1.svg";
export { ForwardRef as ReactComponent };